import type { MarketDemandLevel } from 'lumen/utils/constants/general-constants';
import {
  MARKET_DEMAND_LEVELS,
  MARKET_DEMAND_UPPER_BOUNDS,
} from 'lumen/utils/constants/general-constants';

/**
 * Calculates the demand level based on the demand value.
 * @param demandValue - The demand value (0-1 range, where 1 = 100%)
 * @returns The corresponding demand level, or null if the value is null/undefined
 */
export function getDemandLevel(
  demandValue: number | null | undefined,
): MarketDemandLevel | null {
  if (demandValue === null || demandValue === undefined) {
    return null;
  }

  if (demandValue < MARKET_DEMAND_UPPER_BOUNDS[MARKET_DEMAND_LEVELS.VERY_LOW]) {
    return MARKET_DEMAND_LEVELS.VERY_LOW;
  }
  if (demandValue < MARKET_DEMAND_UPPER_BOUNDS[MARKET_DEMAND_LEVELS.LOW]) {
    return MARKET_DEMAND_LEVELS.LOW;
  }
  if (demandValue < MARKET_DEMAND_UPPER_BOUNDS[MARKET_DEMAND_LEVELS.NORMAL]) {
    return MARKET_DEMAND_LEVELS.NORMAL;
  }
  if (demandValue < MARKET_DEMAND_UPPER_BOUNDS[MARKET_DEMAND_LEVELS.ELEVATED]) {
    return MARKET_DEMAND_LEVELS.ELEVATED;
  }
  if (demandValue < MARKET_DEMAND_UPPER_BOUNDS[MARKET_DEMAND_LEVELS.HIGH]) {
    return MARKET_DEMAND_LEVELS.HIGH;
  }
  return MARKET_DEMAND_LEVELS.VERY_HIGH;
}
